import shared from '../shared';

export default { ...shared };
